import React from 'react'
import { DefaultButton, Panel, PanelType, PrimaryButton } from '@fluentui/react';
import Calendar from "react-calendar";
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';

import { useTranslation } from "react-i18next";

import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import "react-calendar/dist/Calendar.css";
import './style-calendar.css'
import { useBoolean } from '@fluentui/react-hooks';
import { useContext } from 'react';
import MainAppContext from '../../../../../MainAppContext';
import { parseMesAnioEs, setBoardCalendarFilterConfig } from '../../../../../common/Helpers';
import { _global_buttonStyles } from '../../../../../common/ObjectStructures/Trasnversal';
import { __BoardCalendarFilter, enum__BoardCalendarFilter } from '../../../../../common/Dictionaries';
import PropTypes from 'prop-types';
import { action_setAllBoardViewNull, action_updateBoardDataseriesList } from '../../../../../reducers/actions/KPI/actions';
import { useDispatch } from 'react-redux';

function CalendarFilterPanel(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const dispatch = useDispatch();

    const { 
        inputParam_IsPanelOpen = false,
        inputParam_SetterIsPanelOpen = null,
        inputParam_SetDataserieFullListToNull = null,
    } = props;
    
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [selectedStartDate, setSelectedStartDate] = useState([contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate, contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate]);

    const onClickDate = (value) => {
        setSelectedStartDate(value);
    }

    const calendarConfigStructure = {
        maxDetail:"year",
        minDetail:"month",
        selectRange:false,
        showDoubleView:false,
        onChange:onClickDate,
        returnValue:"range"
    }

    const [calendarConfig, setCalendarConfig] = useState(calendarConfigStructure);
    const [calendarSelectorId, setCalendarSelectorId] = useState(enum__BoardCalendarFilter.FIXED_MONTH);
    
    const onFilter = (e) => {
        const rangeStart = document.querySelector('.react-calendar__tile--rangeStart');

        contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId = calendarSelectorId
        contextSite.kpiModule.boardCalendarFilterConfig.value.fireFilter = true
        
        if (rangeStart && contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId === 9) {
            const startMonth = rangeStart.children[0].getAttribute('aria-label');

            const date = parseMesAnioEs(startMonth);

            const fechaInicial = date.clone().subtract(2, 'months').startOf('month').toDate();
            const fechaFinal = date.endOf('months').toDate();

            contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate =fechaInicial
            contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate = fechaFinal

            setSelectedStartDate([fechaInicial, fechaFinal]);
        }
        else{
            contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate = selectedStartDate[0]
            contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate = selectedStartDate[1]
        }

        setBoardCalendarFilterConfig(contextSite.kpiModule.boardCalendarFilterConfig.value)
        
        contextSite.kpiModule.boardCalendarFilterConfig.setter(prevState => ({
            ...prevState,
            fireFilter: true,
            calendarSelectorId: calendarSelectorId,
            periodStartDate: contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate,
            periodEndsDate: contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate
        }))

        dispatch(action_updateBoardDataseriesList(null, true));

        
        dispatch(action_setAllBoardViewNull());

        inputParam_SetDataserieFullListToNull && inputParam_SetDataserieFullListToNull(prevState => ({
            ...prevState,
            revisionDataserieFullList: null,
            gapFishboneList: null,
            fireUpdateLastAction: true
        }))

        window.location.href = window.location.href;

        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return <div>
                    <PrimaryButton onClick={onFilter} styles={_global_buttonStyles}>{t('data-lang-btn-filter')}</PrimaryButton>
                    <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
                </div>
    }

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };
    
    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    return (
        <>
            <div>
                <Panel
                    isOpen={ inputParam_IsPanelOpen }
                    isLightDismiss={ true }
                    onLightDismissClick={ showDialog }
                    onDismiss={ onDismissPanel }
                    headerText={ t('data-lang-boxname-filters') }
                    closeButtonAriaLabel={ t('data-lang-btn-close') }
                    isFooterAtBottom={ true }
                    onRenderFooterContent={ onRenderFooterContent }
                    customWidth={ PanelType.medium }
                    type={ PanelType.medium }
                >
                    <Row className="pt-3">
                        <Col xl={12} align="center">
                            <div className='calendar-layer-block'>
                                <Calendar
                                    className={"disabledbutton box"}
                                    onChange={onClickDate}
                                    returnValue={calendarConfig.returnValue}
                                    value={selectedStartDate ? selectedStartDate : null}
                                    selectRange={calendarConfig.selectRange}
                                    showNeighboringMonth={false}
                                    maxDate={new Date()}
                                    minDetail={calendarConfig.minDetail}
                                    maxDetail={calendarConfig.maxDetail}
                                    showDoubleView={calendarConfig.showDoubleView}
                                    formatLongDate={(locale, date) => moment(date).format("DD/MM/YYYY")}
                                    locale={"es-ES"}
                                />
                            </div>
                        </Col>
                    </Row>
                </Panel>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </div>            
        </>
    );
}

CalendarFilterPanel.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_SetDataserieFullListToNull: PropTypes.func,
};

export default CalendarFilterPanel;